module.exports = __webpack_public_path__ + "static/media/battery-csm.632fc668.png";